import { render, staticRenderFns } from "./RentReject.vue?vue&type=template&id=d052703a&"
import script from "./RentReject.vue?vue&type=script&lang=js&"
export * from "./RentReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports